/* eslint-disable no-restricted-imports */
import { makeStyles } from "@material-ui/core/styles";
import { Formik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { Select } from "../../../../_metronic/_partials/controls";
import { useSchoolContext } from "./SchoolDataContext";

const initialFilterValues = {
  nameFilter: "",
  emailFilter: "",
  phoneFilter: "",
  activeFilter: "",
};

const prepareFilter = (values) => {
  const { nameFilter, emailFilter, phoneFilter, activeFilter } = values;
  const filter = {};

  filter.school_name = nameFilter !== "" ? nameFilter : "";
  filter.primary_email = emailFilter !== "" ? emailFilter : "";
  filter.primary_phone = phoneFilter !== "" ? phoneFilter : "";
  filter.active_id = activeFilter !== "" ? activeFilter : "";

  return filter;
};

export function SchoolFilter({ filterData, origData, loading }) {
  const formRef = useRef();
  const DROPDOWN_ACTIVE = useSchoolContext().ACTIVE;
  const current_branch = useSelector(
    (state) => state.auth.branches.currentBranch,
    shallowEqual
  );

  const [dataLoaded, setDataLoaded] = useState(false);
  const context = useSchoolContext();

  const applyFilter = (values) => {
    //apply filter here
    filterData(prepareFilter(values));
  };

  const useStyles = makeStyles({
    btnCircleSm: {
      width: "30px",
      height: "30px",
      padding: "0px 7px",
      margin: "2px 1px 1px 1px",
      borderRadius: "15px",
      fontSize: "4px",
      textAlign: "center",
    },
  });
  const classes = useStyles();

  useEffect(() => {
    applyFilter(initialFilterValues);
  }, [origData]);

  // fetching data when context refetches
  useEffect(() => {
    formRef.current.click();
  }, [context.refetch, loading]);

  return (
    <>
      <Formik
        initialValues={initialFilterValues}
        onSubmit={(values) => {
          applyFilter(values);
        }}
      >
        {({ values, handleSubmit, handleBlur, setFieldValue }) => (
          <fieldset className="mb-3" disabled={context.isLoading}>
            <form onSubmit={handleSubmit} className="form form-label-right">
              <div className="form-group row">

                <div className="col-lg-3">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="School Name"
                    name="nameFilter"
                    onBlur={handleBlur}
                    onChange={(e) => {
                      setFieldValue("nameFilter", e.target.value);
                      handleSubmit();
                    }}
                    value={values.nameFilter}
                  />
                  <small className="form-text text-muted">
                    <b>Filter</b> by School Name
                  </small>
                </div>

                <div className="col-lg-2">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Email"
                    name="emailFilter"
                    onBlur={handleBlur}
                    onChange={(e) => {
                      setFieldValue("emailFilter", e.target.value);
                      handleSubmit();
                    }}
                    value={values.emailFilter}
                  />
                  <small className="form-text text-muted">
                    <b>Filter</b> by Email
                  </small>
                </div>

                <div className="col-lg-2">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Phone"
                    name="phoneFilter"
                    onBlur={handleBlur}
                    onChange={(e) => {
                      setFieldValue("phoneFilter", e.target.value);
                      handleSubmit();
                    }}
                    value={values.phoneFilter}
                  />
                  <small className="form-text text-muted">
                    <b>Filter</b> by Phone
                  </small>
                </div>

                <div className="col-lg-2">
                  <Select
                    placeholder="Filter by Status"
                    name="activeFilter"
                    validationColorScheme={false}
                    isClearable={true}
                    onChange={(e) => {
                      setFieldValue("activeFilter", e ? e.value : "");
                      handleSubmit();
                    }}
                  >
                    {DROPDOWN_ACTIVE.ACTIVES &&
                      Array.isArray(DROPDOWN_ACTIVE.ACTIVES) &&
                      DROPDOWN_ACTIVE.ACTIVES.map((a) => (
                        <option key={a.value} value={a.value}>
                          {a.label}
                        </option>
                      ))}
                  </Select>
                  <small className="form-text text-muted">
                    <b>Filter</b> by Status
                  </small>
                </div>

                <button
                  type="submit"
                  ref={formRef}
                  style={{ display: "none" }}
                  onClick={handleSubmit}
                />
              </div>
            </form>
          </fieldset>
        )}
      </Formik>
    </>
  );
}
